import { FC } from 'react'
import styled from 'styled-components'

import UpCaret from 'components/SVG/UpCaret'
import UpCaretRounded from 'components/SVG/UpCaretRounded'

interface IRotatedProps {
  rotated?: boolean
}
const ArrowContainer = styled.div<IRotatedProps>`
  width: 12px;
  height: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: ${props => (props.rotated ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: all 0.35s ease-in-out;
  padding-top: 2px;
`

interface IProps {
  rotated?: boolean
  fill?: string
  strokecap?: 'butt' | 'rounded'
}

const RotatingArrow: FC<IProps> = ({ rotated, fill, strokecap = 'butt' }) => (
  <ArrowContainer rotated={rotated}>
    {strokecap === 'butt'
      ? (
        <UpCaret
          width={11}
          height={8}
          fill={fill || 'black'}
        />
      )
      : (
        <UpCaretRounded
          width={12}
          height={7}
        />
      )}
  </ArrowContainer>
)

export default RotatingArrow
